import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { Button } from '../ui/Button';
import type { UserPersona } from '../../types/cabinet.types';

interface EmptyConsultationsProps {
  /** H-5: тип персони для вибору правильного CTA */
  personaType?: UserPersona;
  /** H-5: для Персони C — коллбек переходу на ServicesPage всередині кабінету */
  onServicesClick?: () => void;
}

export const EmptyConsultations: React.FC<EmptyConsultationsProps> = ({
  personaType,
  onServicesClick,
}) => {
  const { t } = useI18n();

  const handleAction = () => {
    if (personaType === 'C' && onServicesClick) {
      onServicesClick();
    } else if (typeof window !== 'undefined' && window.cabinetVars?.siteUrl) {
      window.location.href = window.cabinetVars.siteUrl;
    }
  };

  const subtitle = t('empty_cons_sub') || 'Zacznij od pierwszej konsultacji — jesteśmy tu dla Ciebie';
  const actionText = t('empty_cons_btn') || 'Umów wizytę';

  return (
    <div className="cab-empty-cons-wrap">
      <div className="cab-empty-cons-card">
        <div className="cab-empty-cons-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
            <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" />
            <circle cx="20" cy="10" r="2" />
          </svg>
        </div>
        <h3 className="cab-empty-cons-title">{t('empty_cons_title') || 'Nie masz jeszcze wizyt'}</h3>
        <p className="cab-empty-cons-sub">{subtitle}</p>
      </div>

      <Button 
        variant="primary" 
        onClick={handleAction}
        className="cab-empty-cons-btn"
      >
        {actionText}
      </Button>

      <style>{`
        .cab-empty-cons-wrap {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .cab-empty-cons-card {
          background: var(--cab-purple-main, #E6D6FA);
          border-radius: 24px;
          padding: 40px 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 16px;
        }
        .cab-empty-cons-icon {
          color: var(--cab-violet, #361777);
          margin-bottom: 8px;
        }
        .cab-empty-cons-title {
          font-family: 'Poppins', sans-serif;
          font-weight: 700;
          font-size: 24px;
          color: var(--cab-violet, #361777);
          margin: 0;
        }
        .cab-empty-cons-sub {
          font-family: 'Poppins', sans-serif;
          font-weight: 500;
          font-size: 16px;
          color: var(--cab-violet, #361777);
          margin: 0;
          line-height: 1.5;
        }
        .cab-empty-cons-btn {
          width: 100%;
          padding: 16px;
          border-radius: 100px;
          font-size: 16px;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};
